/* SET STATE */
export const SET_STATE_LABREQUESTTEST = "SET_STATE_LABREQUESTTEST"

/* LABREQUESTTESTS */
export const GET_LABREQUESTTESTS = "GET_LABREQUESTTESTS"
export const GET_LABREQUESTTESTS_SUCCESS = "GET_LABREQUESTTESTS_SUCCESS"
export const GET_LABREQUESTTESTS_FAIL = "GET_LABREQUESTTESTS_FAIL"

/* LABREQUESTTEST */
export const GET_LABREQUESTTEST = "GET_LABREQUESTTEST"
export const GET_LABREQUESTTEST_SUCCESS = "GET_LABREQUESTTEST_SUCCESS"
export const GET_LABREQUESTTEST_FAIL = "GET_LABREQUESTTEST_FAIL"

/**
 * ADD LABREQUESTTEST
 */
 export const ADD_NEW_LABREQUESTTEST = "ADD_NEW_LABREQUESTTEST"
 export const ADD_LABREQUESTTEST_SUCCESS = "ADD_LABREQUESTTEST_SUCCESS"
 export const ADD_LABREQUESTTEST_FAIL = "ADD_LABREQUESTTEST_FAIL"

 /**
 * UPDATE LABREQUESTTEST
 */
export const UPDATE_LABREQUESTTEST = "UPDATE_LABREQUESTTEST"
export const UPDATE_LABREQUESTTEST_SUCCESS = "UPDATE_LABREQUESTTEST_SUCCESS"
export const UPDATE_LABREQUESTTEST_FAIL = "UPDATE_LABREQUESTTEST_FAIL"

/**
 * DELETE LABREQUESTTEST
 */
export const DELETE_LABREQUESTTEST = "DELETE_LABREQUESTTEST"
export const DELETE_LABREQUESTTEST_SUCCESS = "DELETE_LABREQUESTTEST_SUCCESS"
export const DELETE_LABREQUESTTEST_FAIL = "DELETE_LABREQUESTTEST_FAIL"

/**
 * MASSIVE STATUS UPDATE
 */
export const MASSIVE_STATUS_UPDATE = "MASSIVE_STATUS_UPDATE";
export const MASSIVE_STATUS_UPDATE_SUCCESS = "MASSIVE_STATUS_UPDATE_SUCCESS";
export const MASSIVE_STATUS_UPDATE_FAIL = "MASSIVE_STATUS_UPDATE_FAIL";
